
/**
 * 专家路由
 */
import Layout from '@/baseLayout/LayoutPage'
const roleSpecial = "special"
export const routesSP = {
        path: "/special",
        name:"special",
        component:Layout,
    redirect:"/special/specialinfo",
        children:[
            {
                path: 'specialinfo',
                component: () => import(/* webpackChunkName: "about" */ '../views/special/SpecialinfoView.vue'),
                meta:{title:"专家信息",menuShow:true,role:roleSpecial}
            },
            {
                path: 'firstscoring',
                component: () => import(/* webpackChunkName: "about" */ '../views/special/ReviewFirstScoring.vue'),
                meta:{title:"初赛评审打分",menuShow:true,role:roleSpecial}
            },
            {
                path: 'secondscoring',
                component: () => import(/* webpackChunkName: "about" */ '../views/special/ReviewSecondScoring.vue'),
                meta:{title:"复赛评审打分",menuShow:true,role:roleSpecial}
            },
            {
                path: 'entryscoring',
                component: () => import(/* webpackChunkName: "about" */ '../views/special/EntryScoringView.vue'),
                meta:{title:"作品评分",menuShow:false,'role':roleSpecial}
            },
        ]
    }

